import React from "react";
import { Divider } from "@mui/material";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import StyleOutlinedIcon from "@mui/icons-material/StyleOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { SidebarItem } from "./SpecsEditorFields/index";
import { SPECULOOS_NAV_KIND } from "./types";
import { useSpecsEditorContextValue } from "./useSpecsEditor";

export default function SpecsModeSelectorSidebar() {
  const {
    editor,
    nav,
    selectedPanelKind,
    selectSettings,
    selectHistory,
    selectPositions,
    selectParts,
    selectElements,
    selectStyles,
    selectImport,
    selectShipping,
    selectedPositionId,
    handleSelectDesign,
    selectMetadata,
    selectGlobal,
  } = useSpecsEditorContextValue();
  const hasEditableProductSession = Boolean(editor.specsModel);
  const hasSelectedProduct = Boolean(
    editor.identity.productName && editor.identity.productVersion
  );

  return (
    <>
      <SidebarItem
        icon={<FileUploadOutlinedIcon />}
        label="Import"
        active={nav.kind === SPECULOOS_NAV_KIND.IMPORT}
        onClick={selectImport}
      />
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<InfoOutlinedIcon />}
          label="Metadata"
          active={nav.kind === SPECULOOS_NAV_KIND.METADATA}
          onClick={selectMetadata}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<SettingsOutlinedIcon />}
          label="Paramètres"
          active={nav.kind === SPECULOOS_NAV_KIND.SETTINGS}
          onClick={selectSettings}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<TuneOutlinedIcon />}
          label="Positions"
          active={nav.kind === SPECULOOS_NAV_KIND.POSITIONS}
          onClick={() => selectPositions(selectedPositionId ?? undefined)}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<CategoryOutlinedIcon />}
          label="Parts"
          active={nav.kind === SPECULOOS_NAV_KIND.PARTS}
          onClick={selectParts}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<DesignServicesOutlinedIcon />}
          label="Éléments"
          active={nav.kind === SPECULOOS_NAV_KIND.ELEMENTS}
          onClick={selectElements}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<StyleOutlinedIcon />}
          label="Styles"
          active={nav.kind === SPECULOOS_NAV_KIND.STYLES}
          onClick={selectStyles}
        />
      ) : null}
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<PublicOutlinedIcon />}
          label="Global"
          active={nav.kind === SPECULOOS_NAV_KIND.GLOBAL}
          onClick={selectGlobal}
        />
      ) : null}
      <SidebarItem
        icon={<BrushOutlinedIcon />}
        label="Design"
        active={selectedPanelKind === "layer"}
        onClick={handleSelectDesign}
      />
      {hasEditableProductSession ? (
        <SidebarItem
          icon={<LocalShippingOutlinedIcon />}
          label="Shipping"
          active={nav.kind === SPECULOOS_NAV_KIND.SHIPPING}
          onClick={selectShipping}
        />
      ) : null}
      {hasSelectedProduct ? (
        <SidebarItem
          icon={<HistoryOutlinedIcon />}
          label="Historique"
          active={nav.kind === SPECULOOS_NAV_KIND.HISTORY}
          onClick={selectHistory}
        />
      ) : null}
      <Divider sx={{ my: 0.5 }} />
    </>
  );
}
